import React from 'react';
import {Panel} from "primereact/panel";

// Mode-aware explanation shown directly under the pricing-mode picker on all
// three dynamic-pricing screens (campaign wizard, product detail, campaign
// list). `mode` mirrors pricing_strategy.guarantee_buybox: false = undercut
// competitors, true = guarantee buybox. Kept as a single shared component so
// the copy only lives in one place (see the i18n keys under reprice.guide_*).
const PricingModeGuide = ({t, mode}) => {
    const summary = t(mode ? 'reprice.guide_buybox_summary' : 'reprice.guide_undercut_summary');
    const howItWorks = t(mode ? 'reprice.guide_buybox_how' : 'reprice.guide_undercut_how');

    return (
        <div className="pux-guide">
            <div className="pux-guide-summary">
                <i className="pi pi-info-circle"/>
                <span>{summary}</span>
            </div>
            {/* Closed by default -- a concrete numeric walkthrough, opt-in. */}
            <Panel header={t('reprice.guide_how_it_works')} toggleable collapsed className="pux-guide-panel">
                <div className="pux-guide-how">{howItWorks}</div>
            </Panel>
        </div>
    );
};

export default PricingModeGuide;
